var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneWayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6135",
    "data-name": "Group 6135",
    transform: "translate(-860 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6151",
    "data-name": "Group 6151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6109",
    "data-name": "Group 6109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3992",
    "data-name": "Rectangle 3992",
    width: 50,
    height: 16,
    rx: 8,
    transform: "translate(860 24)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1-way",
    "data-name": "1-way",
    transform: "translate(866 26)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "1-way")))), /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-short",
    transform: "translate(904.137 28) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4491",
    "data-name": "Path 4491",
    d: "M.171,4.48a.581.581,0,0,0,.823,0L4.068,1.4,7.144,4.48a.582.582,0,1,0,.823-.823L4.48.171a.581.581,0,0,0-.823,0L.171,3.657a.581.581,0,0,0,0,.823Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4492",
    "data-name": "Path 4492",
    d: "M.581,6.973a.581.581,0,0,0,.581-.581V.581A.581.581,0,0,0,0,.581V6.392A.581.581,0,0,0,.581,6.973Z",
    transform: "translate(3.487 1.163)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneWayIcon);
export default __webpack_public_path__ + "static/media/one-way-icon.31132300.svg";
export { ForwardRef as ReactComponent };